type LOCAL_DATA_KEYS = 'notify_count' | 'dont_next_show_tutorial' | "last_notification_dt";
export class LocalMemory {
  PROJECT_SESSION = 'project';
  POLY_SEARCH_KEY = 'poly_search_key';
  IS_CLOSE_SUB_WIN = 'is_close_sub_win';
  IS_OPEN_HELP = 'is_open_help';
  SAVED_AT_PLAY = 'saved_at_play';

  private constructor() {
    //
  }

  static get instance(): LocalMemory {
    return new LocalMemory();
  }
  /**
   * 実行サブウィンドウの閉じた状態を覚えておくメソッド
   */
  setCloseSubWin(): void {
    sessionStorage.setItem(this.IS_CLOSE_SUB_WIN, 'true');
  }

  /**
   * 実行サブウィンドウの開いた状態をSessionStrageで覚えておくメソッド
   */
  setOpenSubWin(): void {
    sessionStorage.setItem(this.IS_CLOSE_SUB_WIN, 'false');
  }

  /**
   * 初回実行時に保存ダイアログを出すときの判断用メソッド
   * SessionStrageに日付がなければ、初回保存とみなす
   * @param {} project_id
   */
  isSavedAtPlay(project_id: string): boolean {
    const savedTable = localStorage.getItem(this.SAVED_AT_PLAY);
    let isSaved = false;

    if (savedTable) {
      const savedTableObj = JSON.parse(savedTable);

      // プロジェクトIDまでとれたらTrue
      if (savedTableObj != null) {
        const savedDate = savedTableObj[project_id];
        if (savedDate != null) {
          isSaved = true;
        }
      }
    }
    return isSaved;
  }

  /**
   * 初回実行時に保存ダイアログを出す判断のために、保存しておくメソッド
   * @param {} project_id
   */
  savedAtPlay(project_id: string): any {
    const savedAtPlay = localStorage.getItem(this.SAVED_AT_PLAY);
    let savedTable;
    if (savedAtPlay) {
      savedTable = JSON.parse(savedTable);
    } else {
      savedTable = {};
    }
    savedTable[project_id] = new Date();

    localStorage.setItem(this.SAVED_AT_PLAY, JSON.stringify(savedTable));
    return savedTable;
  }

  isCloseHelp(): boolean {
    // チェックして取れなければfalseを書き込んでおく
    if (!localStorage.getItem(this.IS_OPEN_HELP)) {
      localStorage.setItem(this.IS_OPEN_HELP, 'true');
    }

    // IS_OPEN_HELP がtrueの時は、falseつまり OPEN
    // IS_OPEN_HELP 取れない時は、falseつまり OPEN
    return !(localStorage.getItem(this.IS_OPEN_HELP) === 'true');
  }

  toCloseHelp(): void {
    localStorage.setItem(this.IS_OPEN_HELP, 'false');
  }

  toOpenHelp(): void {
    localStorage.setItem(this.IS_OPEN_HELP, 'true');
  }

  /**
   * セッション中1回だけ実行する
   * @param  {String} key      セッションを判断するキー
   * @param  {Function} execFunc 実行する関数
   * @param  {Function} else時に実行する関数
   * @param  {Object} args     実行する関数の引数
   * @return {Object}
   */
  sessionOnce(key: string, execFunc: (any) => any, elseFunc: (any) => any, args: any): any {
    const executed = sessionStorage.getItem(key);
    let result = {};
    if (!executed) {
      result = execFunc(args);
      sessionStorage.setItem(key, 'true');
    } else {
      result = elseFunc(args);
    }
    return { result: result, executed: !executed };
  }

  getProjectFromSessionStorage(project_id: string): any {
    let project = sessionStorage.getItem(this.PROJECT_SESSION + project_id);
    if (project) {
      project = JSON.parse(project);
    }
    return project;
  }

  setProjectToSessionStorage(project_id, data) {
    sessionStorage.setItem(this.PROJECT_SESSION + project_id, JSON.stringify(data));
  }

  setPolySearchedWord(keyword) {
    sessionStorage.setItem(this.POLY_SEARCH_KEY, keyword);
  }

  getPolySearchedWord() {
    return sessionStorage.getItem(this.POLY_SEARCH_KEY);
  }

  /**
   * 実行サブウィンドウが閉じた状態であることを調べるメソッド
   */
  isCloseSubWin() {
    const isClose = sessionStorage.getItem(this.IS_CLOSE_SUB_WIN);
    if (isClose === 'true') {
      return true;
    } else {
      return false;
    }
  }

  setLocal(key: LOCAL_DATA_KEYS, value: string | number | boolean): void {
    localStorage.setItem(key, value.toString());
  }

  getLocal(key: LOCAL_DATA_KEYS): string {
    return localStorage.getItem(key);
  }

  existsKey(key: LOCAL_DATA_KEYS): boolean {
    for (let i = 0; i < localStorage.length; i++) {
      if (key === localStorage.key(i)) {
        return true;
      }
    }
    return false;
  }

  isDontTutorialShow(): boolean {
    return this.getLocal('dont_next_show_tutorial') === 'true' ? true : false;
  }

  setDontTutorialShow(value: boolean): void {
    return this.setLocal('dont_next_show_tutorial', value);
  }

  existsNotifyCount(): boolean {
    return this.existsKey('notify_count');
  }

  getNotifyCount(): number | null {
    const notify = this.getLocal('notify_count');
    if (!notify && notify !== '0') {
      return null;
    } else {
      return Number(this.getLocal('notify_count'));
    }
  }

  setNotifyCount(num: number): void {
    this.setLocal('notify_count', num);
  }
}
